
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table } from "@common/src/utils/decorator";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
import _ from "lodash-es";
const guidance = namespace("guidance");
const finance = namespace("finance");
const base = namespace("base");

@Component({})
@Table("loadListData")
export default class JingyouQueryRecord extends Vue {
  @finance.Action getBillList;
  @guidance.Action queryConsumeOrder;
  @base.Action getDictionaryList;
  dayjs = dayjs;
  splitThousands = splitThousands;
  emptyToLine = emptyToLine;
  searchForm = {
    consumeTimeBegin: "",
    consumeTimeEnd: "",
    consumeType: "ACCOUNT_BALANCE"
  };
  consumptionList: any[] = [];
  get searchList() {
    return [
      {
        label: t("v218_0.query-time"),
        type: "daterange",
        value: "",
        prop: "consumeTimeBegin",
        valueDistribute: ["consumeTimeBegin", "consumeTimeEnd"]
      },
      {
        label: t("v218_0.query-type"),
        type: "select",
        value: this.searchForm.consumeType,
        selectList: this.queryTypeList,
        prop: "consumeType"
      }
    ];
  }
  created() {
    this.init();
  }
  //多行文本省略
  filters(value) {
    if (!value) return "";
    if (value.length > 30) {
      return value.slice(0, 30) + "...";
    }
    return value;
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.value;
      }
    });
    this.loadListData();
  }
  summaryData: any = {};
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryConsumeOrder({
      orderItems: this.mix_sortParams,
      ...this.searchForm,
      pageSize: this.mix_pageSize,
      pageNum: this.mix_pageNum
    }).then(data => {
      this.consumptionList = data.data.list;
      this.summaryData = _.pick(data.data, ["consumeNumber", "freeAllowanceNumber", "accountBalanceNumber"]);
      return data;
    });
  }
  queryTypeList = [];
  init() {
    this.getDictionaryList("easyecp_consume_type").then(data => {
      this.queryTypeList = data;
    });
    this.loadListData();
  }
}
